module.exports = __webpack_public_path__ + "img/album21_38.d14860f1.jpg";